import DialogVX from '@/components/common/DialogVX'

const vxDialogPlugin = {}
/*
  let settings = {
    title: '알림',
    resolveText: '닫기',
    resolve: ()=>{ do something... },
  }
  this.$vxAlert("입력이 올바르지 않습니다.");
  this.$vxAlert("입력이 올바르지 않습니다.", ()=>{ do something... });
  this.$vxAlert("입력이 올바르지 않습니다.", { ...settings } );

  let settings = {
    title: '확인',
    resolveText: '확인',
    rejectText: '취소',
    resolve: null,
    reject: null,
  };
  this.$vxConfirm("선택하신 데이터를 삭제하시겠습니까?", ()=>{ do something... });
  this.$vxConfirm("선택하신 데이터를 삭제하시겠습니까?", { ...settings } );
 */
vxDialogPlugin.install = Vue => {
  // console.log('install vxDialog');
  var DialogConstructor = Vue.extend(DialogVX)
  var vxDialog = null

  function createDialog() {
    if (vxDialog == null) {
      vxDialog = new DialogConstructor({
        el: document.createElement('div'),
        data() {
          return {
            view: false,
            warning: false
          }
        }
      })
      document.body.appendChild(vxDialog.$el)
    }
  }
  function alert(message, options = {}) {
    if (typeof options === 'function') {
      options = { resolve: options }
    }
    const settings = {
      title: '알림',
      resolveText: 'OK',
      resolve: null,
      // red: true,
      ...options
    }
    // Handle timer to hide the alert.
    if (settings.time) {
      setTimeout(() => {
        vxDialog.view = false
      }, settings.time)
    }
    //
    createDialog()
    vxDialog.type = 'alert'
    vxDialog.title = settings.title
    vxDialog.message = message
    vxDialog.resolveText = settings.resolveText
    vxDialog.resolve = settings.resolve
    vxDialog.red = settings.red
    vxDialog.view = true
  }
  function confirm(message, options = {}) {
    if (typeof options === 'function') {
      options = { resolve: options }
    }
    const settings = {
      title: '확인',
      resolveText: 'Thực thi',
      rejectText: 'Quay lại',
      resolve: null,
      reject: null,
      ...options
    }
    // console.log('SETTING: ', settings);
    createDialog()
    vxDialog.type = 'confirm'
    vxDialog.title = settings.title
    vxDialog.message = message
    vxDialog.resolveText = settings.resolveText
    vxDialog.rejectText = settings.rejectText
    vxDialog.resolve = settings.resolve
    vxDialog.reject = settings.reject
    vxDialog.view = true
    vxDialog.red = settings.red
  }

  Vue.vxAlert = alert
  Vue.vxConfirm = confirm
  Vue.prototype.$vxAlert = alert
  Vue.prototype.$vxConfirm = confirm
}

export default vxDialogPlugin
